module.exports = __webpack_public_path__ + "img/EACalculateItem2.dea39c75.svg";